<template>
  <div class="top-container">
    <div :class="{ mainMask: true, mainMaskShow: this.isLoginShow }">
      <div class="loginFrom">
        <img
          class="close"
          src="../../assets/delete.png"
          @click="closeLogin"
        />
        <p>用户注册/登录</p>

        <div class="phone">
          <input
            v-on:blur="onPhoneBlur"
            type="text"
            placeholder="请输入手机号"
            v-model="phoneNumber"
          />
        </div>

        <div class="checkCode">
          <input
            v-model="checkCode"
            type="text"
            placeholder="请输入验证码"
          />

          <div class="line"></div>

          <span
            :class="classObject"
            @click="sendCode"
            >{{ !isCountDown ? '发送验证码' : countDownNum }}</span
          >
        </div>

        <div class="agreement">
          <input
            @change="checkAccept"
            type="checkbox"
            v-model="loginChecked"
          />
          <span>已阅读并接受</span>
          <span
            class="agree"
            @click="goToAgreement"
            >《乐龄听书用户协议》</span
          >
        </div>
        <div
          :class="{ login: true, loginEnable: this.loginEnable }"
          @click="loginMethod"
        >
          登录
        </div>
      </div>
    </div>

    <div :class="{ loginOffMask: true, loginOffMaskShow: this.isloginOffMaskShow }">
      <div class="loginOffForm">
        <img
          class="close"
          src="../../assets/delete.png"
          @click="loginOffFormClose"
        />

        <p>请确认注销用户</p>

        <div class="content">账号注销后，将不可恢复，个人信息将会永久删除。请您谨慎操作！</div>

        <div
          class="confirm"
          @click="loginOffConfirm"
        >
          确定
        </div>

        <div
          class="cancel"
          @click="loginOffFormClose"
        >
          取消
        </div>
      </div>
    </div>

    <div class="top">
      <div class="logo">
        <router-link
          :to="{ path: '/' }"
          replace
          ><img src="../../assets/logo.png"
        /></router-link>
      </div>

      <div
        class="login"
        style="position: relative; overflow: visible"
      >
        <div
          class="userName"
          @click="checkLogin"
          @mouseover="loginOutShowMethod"
          @mouseout="loginOutHiddenMethod"
        >
          {{ userName ? userName : '请注册/登录' }}

          <div class="blankDiv"></div>

          <div :class="{ loginOut: true, loginOutShow: this.loginOutShow }">
            <div
              class="btnLoginOut"
              @click="quitLogin"
            >
              退出登录
            </div>

            <div class="btnLoginOutLine"></div>

            <div
              class="btnLoginOff"
              @click="loginOff"
            >
              用户注销
            </div>
          </div>
        </div>

        <div
          v-if="userName"
          class="userAvatar"
        >
          <img src="../../assets/userAvatar.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Head',
  components: {},
  props: {},
  data() {
    return {
      checkCode: '',
      userName: '',
      phoneNumber: '',
      realName: '',
      idCard: '',
      enableLogin: false,
      loginChecked: false,
      isLoginShow: false,
      countDownNum: '发送验证码',
      isCountDown: false,
      classObject: { sendCode: true, sendColor: false },
      loginEnable: false,
      loginOutShow: false,
      isloginOffMaskShow: false,
    };
  },
  computed: {
    listenChange() {
      const { checkCode, phoneNumber, loginChecked, realName, idCard } = this;
      return { checkCode, phoneNumber, loginChecked, realName, idCard };
    },
  },

  watch: {
    listenChange(val) {
      this.checkAllowLogin();
    },
    //   checkCode: function(val) {

    //     this.checkAllowLogin()
    //  },
    //   phoneNumber : function (val) {

    //     this.checkAllowLogin()
    //   },
    //   loginChecked: function (val) {

    //     this.checkAllowLogin()
    //   },
    //   realName: function (val) {

    //     this.checkAllowLogin()
    //   },

    //   idCard: function (val) {

    //     this.checkAllowLogin()
    //   }
  },

  created() {
    console.log('created');
    // 测试放开  上线注释

    // window.localStorage.setItem('userName', '')

    // let forceLogin20240201 = window.localStorage.getItem('forceLogin20240201')
    // if (!forceLogin20240201) {
    //   window.localStorage.setItem('userName', '')
    //   window.localStorage.setItem('forceLogin20240201', 'Login')
    // }

    // window.localStorage.setItem('userName', '乐龄书友0808')
    // this.userName = window.localStorage.getItem('userName')

    this.isLoginShow = window.localStorage.getItem('isLoginShow') == 'true';

    if (this.isLoginShow) {
      this.phoneNumber = window.localStorage.getItem('phoneNumber');
      // this.idCard = window.localStorage.getItem('idCard');
      // this.realName = window.localStorage.getItem('realName');
      this.checkCode = window.localStorage.getItem('checkCode');
      this.loginChecked = window.localStorage.getItem('loginChecked') == 'true';
    }
  },

  mounted() {
    console.log('mounted');

    this.userName = window.localStorage.getItem('userName');

    window.addEventListener('beforeunload', this.handleWindowClose); // 添加监听器
  },

  methods: {
    checkAllowLogin() {
      this.loginEnable =
        this.checkCode && this.validatePhoneNumber(this.phoneNumber) && this.loginChecked;
      // this.validateIdCard(this.idCard) &&
      // this.checkCode &&
      // this.realName &&
      // this.validatePhoneNumber(this.phoneNumber) &&
      // this.loginChecked;
    },

    handleWindowClose(event) {
      if (this.isLoginShow) {
        this.closeLogin();

        event.preventDefault(); // 取消默认行为

        // 这里可以编写处理窗口关闭时需要执行的操作
        console.log('窗口正在被关闭');
      }
    },

    goToAgreement() {
      window.localStorage.setItem('isLoginShow', true);

      window.localStorage.setItem('phoneNumber', this.phoneNumber);

      window.localStorage.setItem('idCard', this.idCard);

      window.localStorage.setItem('realName', this.realName);

      window.localStorage.setItem('checkCode', this.checkCode);

      window.localStorage.setItem('loginChecked', this.loginChecked);

      this.$router.push('/agreement');
    },

    closeLogin() {
      window.localStorage.setItem('isLoginShow', false);

      window.localStorage.setItem('phoneNumber', '');

      window.localStorage.setItem('idCard', '');

      window.localStorage.setItem('realName', '');

      window.localStorage.setItem('checkCode', '');

      window.localStorage.setItem('loginChecked', false);

      this.isLoginShow = false;
    },

    checkLogin() {
      if (!this.userName) {
        this.isLoginShow = true;
        window.localStorage.setItem('isLoginShow', true);

        //this.isLoginShow = window.localStorage.getItem("isLoginShow") == "true";
        this.phoneNumber = window.localStorage.getItem('phoneNumber');
        this.checkCode = window.localStorage.getItem('checkCode');
        this.loginChecked = window.localStorage.getItem('loginChecked') == 'true';
      }
    },

    validateIdCard(idCard) {
      // 定义身份证号的正则表达式
      var idRegex = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;

      if (idRegex.test(idCard)) {
        return true;
      }
      return false;
    },

    validatePhoneNumber(phoneNumber) {
      // 首先判断是否为11位数字
      if (phoneNumber.length !== 11 || isNaN(phoneNumber)) {
        return false;
      }
      // 判断是否以特定号码段开头
      let prefix = phoneNumber.substr(0, 3);
      let validPrefixes = [
        '130',
        '131',
        '132',
        '133',
        '134',
        '135',
        '136',
        '137',
        '138',
        '139',
        '150',
        '151',
        '152',
        '153',
        '155',
        '156',
        '157',
        '158',
        '159',
        '166',
        '170',
        '171',
        '172',
        '173',
        '174',
        '175',
        '176',
        '177',
        '178',
        '180',
        '181',
        '182',
        '183',
        '184',
        '185',
        '186',
        '187',
        '188',
        '189',
      ];
      if (!validPrefixes.includes(prefix)) {
        return false;
      }
      return true;
    },

    loginOffConfirm() {
      this.userName = '';
      window.localStorage.setItem('userName', '');
      this.loginOutShow = false;
      this.isloginOffMaskShow = false;
    },

    loginOffFormClose() {
      this.isloginOffMaskShow = false;
    },

    quitLogin(event) {
      event.stopPropagation();
      this.userName = '';
      window.localStorage.setItem('userName', '');
      this.loginOutShow = false;
    },

    loginOff(event) {
      event.stopPropagation();
      this.loginOutShow = false;
      this.isloginOffMaskShow = true;
    },

    loginOutShowMethod() {
      if (this.userName) {
        this.loginOutShow = true;
      }
    },

    loginOutHiddenMethod() {
      this.loginOutShow = false;
    },

    onPhoneBlur() {
      if (!this.phoneNumber) return;

      if (!this.validatePhoneNumber(this.phoneNumber)) {
        this.$message.error('手机号不符合要求');
      }
    },

    onIdCardBlur() {
      if (!this.idCard) return;

      if (!this.validateIdCard(this.idCard)) {
        this.$message.error('身份证号不符合要求');
      }
    },

    checkAccept() {},

    async sendCode() {
      //2024.04.28  健身气功H5  接口http  网站https  跨域问题
      //  const { data: res } = await this.$http.post(`tingSW/news/newsInfo`, {
      //      id: 4,
      //    })

      //console.log(res.data)

      if (this.countDownNum !== '发送验证码' && this.countDownNum !== '重新发送') {
        // this.$message.error('当前不能发送')
        return;
      }

      if (this.phoneNumber == '') {
        this.$message.error('请输入手机号');
        return;
      }

      if (!this.validatePhoneNumber(this.phoneNumber)) {
        this.$message.error('手机号不符合要求');
        return;
      }

      this.isCountDown = true;
      let seconds = 60; // 设置倒计时的秒数
      this.countDownNum = `${seconds}s`;
      this.classObject = { sendCode: true, sendColor: true };
      const timer = setInterval(() => {
        if (seconds > 0) {
          seconds--; // 每次递减1秒
          if (seconds == 0) {
            this.countDownNum = '重新发送';
            clearInterval(timer);
          } else {
            this.countDownNum = `${seconds}s`;
          }
        }
      }, 1000);

      const { data: res } = await this.$http.post(`user/login/getVeriCode`, {
        phone: this.phoneNumber,
      });

      console.log(res.code);

      if (res.code !== 0) {
        this.$message.error('获取手机号失败！');
      } else {
        this.$message.success('获取验证码成功！');
      }

      // const { data: res } = await this.$http.post(
      //    `ting/forWebSite/getVeriCodeForWebSite`,
      //    {
      //      account: this.phoneNumber,
      //    }
      // )
      // console.log(res);

      //  if (res.errorCode !== 0) {
      //   this.$message.error('获取手机号失败！')
      // }
      // else
      // {
      //   this.$message.success('获取验证码成功！')
      // }
    },

    async loginMethod() {
      if (!this.loginEnable) {
        return;
      }

      if (!this.loginChecked) {
        return;
      }

      if (!this.phoneNumber) {
        this.$message.error('请输入手机号！');
        return;
      }

      // if (!this.realName) {
      //   this.$message.error('请输入真实姓名！');
      //   return;
      // }

      // if (!this.idCard) {
      //   this.$message.error('请输入身份证号！');
      //   return;
      // }

      // if (!this.validateIdCard(this.idCard)) {
      //   this.$message.error('身份证号不符合要求');
      // }

      if (!this.checkCode) {
        this.$message.error('请输入验证码！');
        return;
      }

      //2024.3.20注释  阿里云身份验证到期   后期续费放开即可
      // const { data: res2 } = await this.$http.post(`user/login/idCardCheck`, {
      //   name: this.realName,
      //   idCard: this.idCard,
      // })

      // console.log(res2)

      // if (res2.code !== 0) {
      //   this.$message.error('实名验证失败！')
      //   return
      // }

      const { data: res } = await this.$http.post(`user/login/phoneLogin`, {
        phone: this.phoneNumber,
        code: this.checkCode,
      });

      console.log(res);

      if (res.code !== 0) {
        this.$message.error('登陆失败！');
      } else {
        let fourNumber = this.phoneNumber.substr(this.phoneNumber.length - 4, 4);
        window.localStorage.setItem('userName', '乐龄书友' + fourNumber);
        this.userName = window.localStorage.getItem('userName');
        this.isLoginShow = false;
        window.localStorage.setItem('isLoginShow', false);
        window.localStorage.setItem('phoneNumber', '');
        // window.localStorage.setItem('idCard', '');
        // window.localStorage.setItem('realName', '');
        window.localStorage.setItem('checkCode', '');
        window.localStorage.setItem('loginChecked', false);
      }
    },
  },
};
</script>

<style scoped lang="less">
* {
  margin: 0;
  padding: 0;
}

.top-container {
  background: #f5f8ff;
}

.top {
  height: 88px;
  width: 1200px;
  margin: 0px auto;
}

.top .logo {
  float: left;
  margin-top: 21px;
  width: 169px;
  height: 46px;
}
</style>

<style lang="less" scoped>
@import '../../assets/css/index.less';
</style>
